"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'shortcuts.prompt.title': 'Przełącz Zaawansowane Podpowiedzi',
    'shortcuts.prompt.description': 'Włącza lub wyłącza zaawansowaną strukturę podpowiedzi i system slotów',
};
